import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Passenger, PassengerQuote } from 'src/app/core/models/itinerary.model';
import { SettingsService } from 'src/app/settings/services/settings.service';
import { DOCSADoc } from 'src/app/core/models/docsa.model';
import { ReRouteService } from '../../services/re-route.service';
import { MapItineraryApi } from 'src/app/core/api/mappers/map-itinerary-api.service';

@Component({
  selector: 'app-passenger-form-re-route',
  templateUrl: './passenger-form.component.html'
})
export class PassengerInformationReRouteFormComponent implements OnInit {
  open$: Observable<boolean>;
  passengers$: Observable<PassengerQuote[]>;
  total$: Observable<number>;
  totalDocs$: Observable<number>;
  docs$: Observable<DOCSADoc[]>;
  loading: boolean;
  isAirline$: Observable<boolean>;
  submitted = true;
  docs: DOCSADoc[] = [];
  canSubmit = false;

  @Input() passengersInfo: Passenger[];

  constructor(
    private service: ReRouteService,
    private settingsService: SettingsService,
    private mapItineraryApi: MapItineraryApi
  ) {}

  ngOnInit() {
    this.passengers$ = this.service.getQuoteRequest().pipe(map((quote) => quote.passengers));
    this.total$ = this.service.getQuoteRequest().pipe(map((quote) => quote.passengers.length));
    this.isAirline$ = this.settingsService.getClientIsAirline();
    !this.mapItineraryApi.needAditionalInformation(this.passengersInfo) &&
      this.service.dispatchReviewInitialtate();
  }

  validDocsa(docsa: DOCSADoc, index) {
    this.docs[index] = docsa;
    this.service.dispatchSaveDocsa(this.docs);
    this.canSubmit = this.mapItineraryApi.docsasValid(this.docs) && true;
  }

  submit() {
    this.canSubmit ? this.service.dispatchReviewInitialtate() : false;
  }
}
